<template>
    <section v-if="sortedNearbyHome && sortedNearbyHome.length" :class="theme" class="property-nearby">
        <div class="grid xs-grid-cols-1">
            <div class="flex">
                <b class="f4 text-bold"><a :href="getMSPLink" class="link">{{ linkText }}</a></b>
            </div>
            <template v-if="componentMounted || !dpp.isRentals">
                <mvtNearby  :data="sortedNearbyHome" :sortBy="sortBy" :carousalType="carousalType"></mvtNearby>
                <div class="avg-info" v-if="!sort && !hideFooter">
                    <div>
                        {{getAvg}}
                    </div>
                    <div>
                        <a class="link" v-ga:click @click="popMapView" role="button" v-if="theme === 'newDpp'"><span>{{molang('dpp.propertyNearby.viewOnMap')}}</span><i class="icon-angle-right"></i></a>
                        <a class="link" @click="popMapView" role="button" v-else>{{molang('dpp.propertyNearby.viewOnMap')}}</a>
                    </div>
                </div>
            </template>
        </div>
    </section>
</template>
<script src="./property-nearbyhouse.js"></script>

<style lang="scss">
@use "./property-nearbyhouse.scss" as *;
</style>
